<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal [title]="t('modalsServisbotPromptTitle')" (closeModal)="onClose()">
      <div modal-content>
        <p id="servisbot-prompt-message" class="text-body text-ld-neutral-600">
          @if (isBusinessHours()) {
            {{ t('modalsServisbotPromptBusinessHoursMessage') }}
          } @else {
            {{ t('modalsServisbotPromptAfterHoursMessage') }}
          }
        </p>
      </div>
      <div modal-footer>
        <button id="servisbot-chat-btn" type="button" class="btn-primary-ld-purple w-full" (click)="onOpenChat()">
          {{ t('chatCardHeading') }}
        </button>
        <button
          id="servisbot-continue-btn"
          type="button"
          class="btn-outline-ld-purple w-full"
          (click)="onContinueWithMessage()"
        >
          {{ t('modalsServisbotPromptContinueMessageButton') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
